/**
 * 路由缓存管理组合式函数
 */

import { provide, ref } from "vue";
import { getSessionStorage, setSessionStorage } from "../utils/storage";

export interface RouteInfo {
  fullPath: string;
  pageInfo: any;
}

export interface KeepAliveOptions {
  router?: any; // 可选的router实例
}

/**
 * 路由缓存管理
 */
export function useKeepAlive(options: KeepAliveOptions = {}) {
  const { router } = options;

  const beforeInfos = ref<RouteInfo[]>(JSON.parse(getSessionStorage("beforeInfos") || "[]"));

  const keepAliveComponents = ref<string[]>([]);

  /**
   * 设置页面跳转信息
   */
  const setBeforeInfo = (fullPath: string, pageInfo: any) => {
    let item = beforeInfos.value.find((item) => item.fullPath == fullPath);
    if (item) {
      item.pageInfo = pageInfo;
    } else {
      beforeInfos.value.push({ fullPath, pageInfo });
    }
    setSessionStorage("beforeInfos", JSON.stringify(beforeInfos.value));
  };

  /**
   * 设置路由守卫（需要传入router实例）
   */
  const setupRouterGuards = (routerInstance: any) => {
    // 监听路由变化 需要缓存的页面必须设置组件为 keep-alive 并且设置components name
    routerInstance.beforeEach((to: any, from: any) => {
      setBeforeInfo(to.fullPath, to.meta.pageInfo);
    });

    routerInstance.afterEach((to: any, from: any) => {
      // 判断是否需要缓存当前页面
      if (!keepAliveComponents.value.includes(to.name!)) {
        keepAliveComponents.value.push(to.name!);
      } else {
        // 清除缓存 当上一个页面下标和页面栈步数一致时，说明是返回操作，应该清除缓存，
        // 不然当再次进入这个页面时不会执行mounted,数据埋点上报会有问题
        if (history.state.position == keepAliveComponents.value.findIndex((name: string) => name === from.name)) {
          keepAliveComponents.value = keepAliveComponents.value.filter((name: string) => name !== from.name);
        }
      }
    });
  };

  // 如果传入了router，自动设置守卫
  if (router) {
    setupRouterGuards(router);
  }

  provide("keepAliveComponents", keepAliveComponents);

  return {
    beforeInfos,
    keepAliveComponents,
    setBeforeInfo,
    setupRouterGuards
  };
}
